import { create } from 'zustand'

interface Tag {
    name: string;
    index: number;
}

interface State {
    setTagsDis: (tagsDis: Tag[]) => void
    tagsDis: Tag[]
}

export const tagsDisData = [
    {
        name: 'BODEGA',
        index: 1,
    },
    {
        name: 'CAMPO',
        index: 2,
    },
    {
        name: 'ACTIV.',
        index: 3,
    },
    {
        name: 'M.B.',
        index: 4,
    },
]

export const useTabStore = create<State>((set) => ({
    tagsDis: tagsDisData,
    setTagsDis: (tagsDis) => set({ tagsDis }),
}))
